class Seat {
    id = "";
    number = 0;
    playerId = "";
    name = "";
    card1 = "";
    card2 = "";
    isPlaying = false;
    isDealer = false;
    inGame = false;
    status = "";
    playerMoney = 0;
    bet = 0;
    prize = 0;
    timestamp = "";
    showCheck;
    sitOutTime = "";

    constructor(id, number, playerId, name, card1, card2, isPlaying, isDealer, inGame, status, playerMoney, bet, prize, timestamp, sitOutTime) {
        this.id = id;
        this.number = number;
        this.playerId = playerId;
        this.name = name;
        this.card1 = card1;
        this.card2 = card2;
        this.isPlaying = isPlaying;
        this.isDealer = isDealer;
        this.inGame = inGame;
        this.status = status;
        this.playerMoney = playerMoney;
        this.bet = bet;
        this.prize = prize;
        this.showCheck = false;
        this.timestamp = timestamp;
        this.sitOutTime = sitOutTime;
    }
}

export default Seat;
